import { Positions } from 'constants/enums';
import { useAppSelector } from 'index';
import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

interface PositionRouteProps extends RouteProps {
    positions: Positions[];
    component: React.ComponentType<any>;
}

export default function PositionRoute({
    positions,
    component: Component,
    ...rest
}: PositionRouteProps) {
    const user = useAppSelector((state) => state.user);
    const currentRest = user.restaurants.find((r) => r.id === user.currentRestaurantId);

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!user) {
                    return <Redirect to="/login" />;
                }

                if (
                    currentRest?.currentPosition &&
                    !positions.includes(currentRest?.currentPosition)
                ) {
                    return <Redirect to="/orders" />;
                }

                return <Component {...props} />;
            }}
        />
    );
}
